import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { observable, action } from 'mobx';
import Modal from '../Modal';
import Form, { FormBody, FormActions, TextInput } from '../Form';

@inject('metaDataTemplateStore')
@observer
class MetaDataTemplateAdd extends Component {
  static contextTypes = {
    notify: PropTypes.shape().isRequired,
    router: PropTypes.shape().isRequired,
  };

  static propTypes = {
    route: PropTypes.shape().isRequired,
  };

  slug = '/configurations/meta-data/template';
  title = 'Add Meta Data Template';
  @observable metaDataTemplate = {
    name: '',
    description: '',
  };

  constructor(props) {
    super(props);

    this.onChangeName = this.onChange.bind(this, 'name');
    this.onChangeDescription = this.onChange.bind(this, 'description');
    // this.handleSave = this.handleSave.bind(this);
  }

  @action onChange = (field, event) => {
    this.metaDataTemplate[field] = event.target.value;
  }

  @action handleSave = (e) => {
    e.preventDefault();

    const { notify } = this.context;
    const { metaDataTemplateStore } = this.props;
    metaDataTemplateStore
      .createItem(this.metaDataTemplate)
      .then(() => {
        this.context.router.push(this.slug);
        notify.success({ message: 'Created Meta Data Template' });
      })
      .catch(action((err) => { notify.error(err); }));
  }

  render() {
    // const { route: { metaDataTemplateStore } } = this.props;

    // if (metaDataTemplateStore.isLoading) {
      // return <Loading />;
    // }

    return (
      <Modal title={this.title} slug={this.slug}>
        <Form>
          <FormBody>
            <TextInput label={'Name'} value={this.metaDataTemplate.name}
              onChange={this.onChangeName}
            />
            <TextInput label={'Description'} value={this.metaDataTemplate.description}
              onChange={this.onChangeDescription}
            />
          </FormBody>

          <FormActions>
            <button onClick={this.handleSave}>Save</button>
          </FormActions>
        </Form>
      </Modal>
    );
  }
}


export default MetaDataTemplateAdd;



// WEBPACK FOOTER //
// ./src/components/MetaDataTemplate/MetaDataTemplateAdd.js